// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3JBvc","col":"styles_col__3J2iE","fulfillmentStatus":"styles_fulfillmentStatus__15xd2","emailCol":"styles_emailCol__3lUxV"};